<template>
  <div class="container" v-loading="listLoading" >
    <div class="item" v-for="(item) in List" :key="`${item.display_name}_${item.cacheValue}`" >
        <span class="item-txt" >{{item.display_name}}</span>
        <el-switch v-model="item.value" ></el-switch>
    </div>
    <div class="bottom" v-show="!listLoading" >
        <el-button size="medium" type="warning" @click="submit" >保存</el-button>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
    data(){
        return {
            List:[],
            listLoading:false
        }
    },
    created(){
        this.getSet()
    },
    methods:{
        async getSet(){
            try{
                this.listLoading=true
                let res=await request({
                    url:'/api/backend/settings',
                    method:'GET',
                    params:{
                        prefix:'integral.is_on',
                        system_logs_content:"运营管理-模块管理-列表"
                    }
                })
                this.List=res.data.data.map(item => {
                    console.log(item.value)
                    item.cacheValue=item.value
                    item.value=Boolean(item.value)
                    return item
                })
                console.log(this.List)
                this.listLoading=false
            }catch(err){
                 this.listLoading=false
                console.log(err)
            }
        },
        async submit(){
            console.log(this.List)
            try{
                this.listLoading=true
                let cache={}
                this.List.forEach(item=>{
                    console.log(item.value)
                    cache[item.key]={value:Number(item.value)}
                })
                console.log(cache)
                await request({
                        url: "/api/backend/settings/store",
                        method: "POST",
                        data:cache
                })
                this.$notify({
                    message:"修改成功",
                    type:'success'
                })
                this.getSet()
            }catch(err){
                this.listLoading=false
                console.log(err)
            }
        }
    },
    computed:{}
}
</script>

<style lang="scss" scoped >
    .container{
        padding:20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .item{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin:15px 2vw;
        &-txt{
            font-size: .95em;
            font-weight: bold;
            margin-right: 2vw;
        }
    }
    .bottom{
        width:100%;
        margin-top:5vh;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
</style>